/**
 * Defines all the capabilities
 */
const ALL_CAPABILITIES = ['Cof', 'Lof', 'Rehab', 'ShowOnMapPanel'] as const;

/**
 * Typescript trick to get the types only defined once.
 */
type CapabilityTuple = typeof ALL_CAPABILITIES;

/**
 * Represents the different capabilities that an asset or property can have.
 */
export type Capability = CapabilityTuple[number];

/**
 * List of all capabilities.
 */
export const Capabilities: readonly Capability[] = ALL_CAPABILITIES;
